"use client"

import React, { useRef } from "react"

import BlogCard from "./blogCard"
import { svgs } from "public/assets/svgs"
import { Article } from "@/interface"

const RelatedPosts: React.FC<{ relatedArticles: Article[] }> = ({ relatedArticles }) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null)

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -328, behavior: "smooth" })
    }
  }

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 328, behavior: "smooth" })
    }
  }
  return (
    <div className="mt-16 flex w-full flex-col gap-8 bg-[#FFFFFF] pb-[57px] pl-[39px] pr-8 pt-[44px] md:gap-6 lg:items-center ">
      {/* Title */}
      <div className="mx-auto flex items-center justify-between md:ml-0 md:mr-auto lg:mx-0 lg:w-[960px] xl:w-[1260px]">
        <div className="text-[24px] font-bold tracking-[-3%] text-[#1E1E1E] md:text-[32px] lg:text-[40px]">
          Related <span className=" font-medium text-[#3F3F3FBF]">Posts</span>
        </div>
        {relatedArticles.length > 0 && (
          <div className="hidden gap-2 lg:flex">
            <div
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-xl border border-[#00000014] bg-white"
              onClick={scrollLeft}
            >
              {svgs["arrowLeftIcon"]?.({ fill: "#130E14", height: 20, width: 20 })}
            </div>
            <div
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-xl border border-[#00000014] bg-white"
              onClick={scrollRight}
            >
              {svgs["arrowRightIcon"]?.({ fill: "#130E14", height: 20, width: 20 })}
            </div>
          </div>
        )}
      </div>
      {/* Posts */}
      <div ref={scrollContainerRef} className="no-scrollbar  overflow-scroll  lg:w-[960px] xl:w-[1260px]">
        <div className="flex flex-col gap-8 md:w-[960px] md:flex-row md:gap-6 xl:w-[1260px]">
          <BlogCard articles={relatedArticles} customClassName="md:w-[304px] flex-shrink-0" />
        </div>
      </div>
    </div>
  )
}

export default RelatedPosts
